module.exports = __webpack_public_path__ + "static/media/infaq1.02c3acc0.png";